module.exports = __webpack_public_path__ + "Simple-Line-Icons.78f07e2c2a535c26ef21.woff";


//////////////////
// WEBPACK FOOTER
// /rightcompound/angular/node_modules/simple-line-icons/fonts/Simple-Line-Icons.woff?v=2.4.0
// module id = ../../../../simple-line-icons/fonts/Simple-Line-Icons.woff?v=2.4.0
// module chunks = styles